import { render, staticRenderFns } from "./PurchaseTrainingCheckoutModal.vue?vue&type=template&id=b82e5a1e&"
import script from "./PurchaseTrainingCheckoutModal.vue?vue&type=script&lang=ts&"
export * from "./PurchaseTrainingCheckoutModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports